import { render, staticRenderFns } from "./IntegrantesHomeComp.vue?vue&type=template&id=8170b5c4&scoped=true&"
import script from "./IntegrantesHomeComp.vue?vue&type=script&lang=js&"
export * from "./IntegrantesHomeComp.vue?vue&type=script&lang=js&"
import style0 from "./IntegrantesHomeComp.vue?vue&type=style&index=0&id=8170b5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8170b5c4",
  null
  
)

export default component.exports